"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSubscriptionStatusFromFields = void 0;
/**
 * Computes the subscription status from billing data.
 * Single source of truth — used across admin table, CSV export, data-proxy, and HubSpot sync.
 *
 * CASE logic (from DEV-2143):
 *   CANCELLING             — subscription.status === 'CANCELLING'
 *   ACTIVE                 — subscription_started_at IS NOT NULL AND ended_at IS NULL
 *   CANCELLED_TRIAL        — subscription_started_at IS NULL AND ended_at IS NOT NULL
 *   CANCELLED_SUBSCRIPTION — subscription_started_at IS NOT NULL AND ended_at IS NOT NULL
 *   TRIAL                  — first_trial_started_at IS NOT NULL AND subscription_started_at IS NULL AND ended_at IS NULL
 *   TRIAL_NOT_STARTED      — first_trial_started_at IS NULL
 *   NONE                   — fallback
 */
var computeSubscriptionStatusFromFields = function (params) {
    var subscriptionStatus = params.subscriptionStatus, subscriptionStartedAt = params.subscriptionStartedAt, endedAt = params.endedAt, firstTrialStartedAt = params.firstTrialStartedAt;
    if (subscriptionStatus === 'CANCELLING')
        return 'CANCELLING';
    if (subscriptionStartedAt && !endedAt)
        return 'ACTIVE';
    if (!subscriptionStartedAt && endedAt)
        return 'CANCELLED_TRIAL';
    if (subscriptionStartedAt && endedAt)
        return 'CANCELLED_SUBSCRIPTION';
    if (firstTrialStartedAt && !subscriptionStartedAt && !endedAt)
        return 'TRIAL';
    return 'TRIAL_NOT_STARTED';
};
exports.computeSubscriptionStatusFromFields = computeSubscriptionStatusFromFields;
